<template>
  <div>
    <header>
      <v-row>
        <v-col cols="12">
          <v-alert color="purple" dark dismissible outlined
            >Se tomará para el cálculo de la diferencia de pesos de cada
            paciente, el primer y último registro del rango de fechas
            seleccionado. Si cambia los filtros apriete el botón Calcular para
            re calcular las diferencias. Si elige una sede sin profesionales
            asociados, el botón Calcular estará deshabilitado.</v-alert
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="4">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="datesFormatted"
                label="Fecha desde / hasta"
                readonly
                v-on="on"
                prepend-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" locale="es-ar" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" sm="4" class="filtro-sede">
          <v-select
            :items="sedes"
            item-text="nombre"
            item-value="idObraSocial"
            prepend-icon="mdi-calendar-multiple"
            v-model="sede"
            label="Sede"
            dense
            no-data-text="No hay Sedes configuradas"
            @change="buscarProfesionales"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3" sm="4" class="filtro-sede">
          <v-select
            :items="profsBuscar"
            item-text="nombreProfesional"
            item-value="idProfesional"
            menu-props="auto"
            label="Profesional"
            hide-details
            prepend-icon="mdi-account"
            v-model="prof"
            no-data-text="No hay profesionales para la sede seleccionada"
            dense
          ></v-select>
        </v-col>
        <v-col class="reload-btn">
          <v-btn
            :disabled="!prof && prof !== 0"
            color="primary"
            @click="calcularPesos"
            >Calcular</v-btn
          >
        </v-col>
      </v-row>
    </header>
    <main>
      <v-row>
        <v-col cols="12" md="6" sm="4">
          <v-card>
            <v-card-title>
              <v-text-field
                v-if="listaPacientes.length"
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar Paciente"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="listaPacientes"
              class="elevation-1"
              locale="es-ar"
              item-key="idPaciente"
              :items-per-page="10"
              :search="search"
              ref="myTable"
              :disable-sort="true"
              :hide-default-footer="false"
              no-data-text="Sin datos para los filtros seleccionados"
              :footer-props="{
                itemsPerPageText: 'Pacientes por página',
              }"
            >
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" sm="4">
          <span class="diferencia-total"
            >Diferencia Total: {{ diferenciaTotal }} Kg.</span
          >
        </v-col>
      </v-row>
    </main>
  </div>
</template>
<script>
import reportesMixin from "../../../mixins/reportesMixin";
import { getData } from "../../../api/apiService";
import moment from "moment";

export default {
  name: "PesoPaciente",
  mixins: [reportesMixin],
  data() {
    return {
      menu2: false,
      dates: [],
      sedes: [],
      sede: 0,
      datesFormatted: "",
      selected: null,
      headers: [
        {
          text: "Empleado / Paciente",
          value: "paciente",
        },
        { text: "Fecha Primer Peso", value: "fechaPrimerPeso" },
        { text: "Peso Primer Peso", value: "pesoPrimerPeso" },
        { text: "Fecha Segundo Peso", value: "fechaSegundoPeso" },
        { text: "Peso Segundo Peso", value: "pesoSegundoPeso" },
        { text: "Diferencia Peso", value: "diferenciaPeso" },
      ],
      listaPacientes: [],
      diferenciaTotal: 0,
      search: "",
    };
  },
  watch: {
    dates(val) {
      if (val.length === 2) {
        moment.locale("fr");
        this.datesFormatted =
          moment(val[0]).format("L") + " - " + moment(val[1]).format("L");
        this.menu2 = false;
      }
    },
  },
  methods: {
    setInitialData() {
      const primerDiaMes = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      const diaActual = moment().format("YYYY-MM-DD");
      this.dates = [primerDiaMes, diaActual];
    },
    async calcularPesos() {
      const params = {
        idSede: this.sede,
        fechaDesde: this.dates[0],
        fechaHasta: this.dates[1],
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        idProfesional: this.prof,
      };
      try {
        const pacientesData = await getData("/Dashboard/CalcularPesos", params);
        this.listaPacientes = pacientesData;
        this.diferenciaTotal = parseFloat(
          pacientesData.reduce((acc, item) => {
            return parseFloat(
              parseFloat(item.diferenciaPesoDecimal) + parseFloat(acc)
            );
          }, parseFloat(0))
        ).toFixed(2);
      } catch (error) {
        console.log(error.message);
      }
    },
    buscarProfesionales() {
      if (this.sede === 0) {
        this.getProfesionales();
      } else {
        this.getProfesionalesSede(this.sede);
      }
    },
  },
  async created() {
    this.$loading(true);
    this.setInitialData();
    await this.getSedes();
    await this.getProfesionales();
    this.calcularPesos();
    this.$loading(false);
  },
};
</script>
<style scoped>
.diferencia-total {
  font-size: 1.5rem;
  text-align: right;
  width: 100%;
  display: inline-block;
}
</style>
